import { render } from "./StockEditReport.vue?vue&type=template&id=84971346&scoped=true&ts=true"
import script from "./StockEditReport.vue?vue&type=script&lang=ts"
export * from "./StockEditReport.vue?vue&type=script&lang=ts"

import "./StockEditReport.vue?vue&type=style&index=0&id=84971346&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84971346"]])

export default __exports__